


























































































































































































































































































































































































































import {Getter, Action} from "vuex-class";
import Component from "vue-class-component";
import {
  SelectWings,
  ToggleWings,
  DatePickerWings,
  FastDateDetailWings,
  NumberWings,
  InputWings
} from 'wings-ui-components';
import {PropSync, Watch} from 'vue-property-decorator'
import BaseFilter from "@/components/Filter/BaseFilter";
import {DetailFilterParams} from "@/store/sms/statistic/types";
import {beginningOfCurrentDay, currentDateEnd, dateFilter} from "@/utils/date-util";
import {notifyError, notifyWarning} from "@/utils/notify-helper";
import { MsgTransports } from '@/store/types';
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";

@Component({
  components: {
    NumberWings,
    SelectWings,
    ToggleWings,
    DatePickerWings,
    FastDateDetailWings,
    InputWings
  },
  filters: {dateFilter}
})
export default class SmsDetailFilter extends BaseFilter<DetailFilterParams> {
  @PropSync('showAdditional') is_show_additional!: boolean;
  @PropSync('filterClone') propFilterClone!: any;
  @PropSync('runFilter') propRunFilter!: any;

  @Getter("messageTypes") messageTypesList: any;
  @Getter("messagesStatusList") statusList: any;
  @Getter("messageCategories") messageCategoriesList: any;

  @Action("getSmsStatisticDetail") actionGetItems: any;
  @Action("exportSmsStatisticDetail") actionExport: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getPartnerUsers") actionGetPartnerUsers: any;
  @Action("getOriginators") actionGetOriginators: any;
  @Action("getServiceProviders") actionGetServiceProviders: any;
  @Action("getAccounts") actionGetAccounts: any;
  @Action("getMessageTypes") actionGetMessageTypes: any;
  @Action("getMessageCategories") actionMessageCategories: any;
  @Action("actionLog") actionLog: any;

  defaultFilter(): DetailFilterParams {
    return {
      date_from: beginningOfCurrentDay(),
      date_to: currentDateEnd(),
      originator: null,
      recipient: null,
      partner: null,
      service_provider: null,
      status: null,
      message_category:null,
      error_code: null,
      message_type: null,
      sent_date_from: null,
      sent_date_to: null,
      deliver_date_from: null,
      deliver_date_to: null,
      template_id: null,
      bulk_id: null,
      operator: null,
      broker_account_login: null,
      partner_user_login: null,
      id: null,
      transport_message_id: null,
      external_id: null,
      ext_id1: null,
      ext_id2: null,
      ext_id3: null,
      ext_id4: null,
      ext_id5: null,
      page_number: 1,
      message_direction: 'mt',
    }
  }

  params: object = {transport: MsgTransports.SMS};
  partnersList: any = []
  originatorsList: any = []
  accountsList: any = []
  partnerUsersList: any = []
  partnerUsersEmailList: any = []
  serviceProvidersList:  any = []

  filterKeys: object = {
    "originator" : "addresser",
    "recipient" : "receiver",
    "broker_account_login" : "account",
    "transport_message_id" : "smpp_message_id",
    "partner_user_login": "partner_login"
  }

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getOriginatorsList(filter: any) {
    const items = await this.actionGetOriginators({...this.params, ...filter});
    this.originatorsList = (filter?.page_number > 1) ? this.originatorsList.concat(items) : items
  }

  async getAccountsList(filter: any) {
    const items = await this.actionGetAccounts({...this.params, ...filter});
    this.accountsList = (filter?.page_number > 1) ? this.accountsList.concat(items) : items
  }

  async getPartnerUsersList(filter: any) {
    if (this.filter.partner) filter = {...filter, partner: this.filter.partner}
    const items = await this.actionGetPartnerUsers({...this.params, ...filter});
    this.partnerUsersList = (filter?.page_number > 1) ? this.partnerUsersList.concat(items) : items
  }

  async getPartnerUsersEmailList(filter: any) {
    if (this.filter.partner) filter = {...filter, partner: this.filter.partner}
    const items = await this.actionGetPartnerUsers({...this.params, ...filter});
    this.partnerUsersEmailList = (filter?.page_number > 1) ? this.partnerUsersEmailList.concat(items) : items
  }

  async getServiceProvidersList(filter: any) {
    const items = await this.actionGetServiceProviders({...this.params, ...filter});
    this.serviceProvidersList = (filter?.page_number > 1) ? this.serviceProvidersList.concat(items) : items
  }

  async created() {
    try {
      this.actionMessageCategories(this.params);
      this.actionGetMessageTypes(this.params);
      this.scroll();
    } catch (err) {
      notifyError(err);
    }
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
    if (this.filter.originator) this.originatorsList = await this.actionGetOriginators({originator: this.filter.originator});
    if (this.filter.broker_account_login) this.accountsList = await this.actionGetAccounts({login: this.filter.broker_account_login});
    if (this.filter.partner_user_login) this.partnerUsersList = await this.actionGetPartnerUsers({email: this.filter.partner_user_login});
    if (this.filter.service_provider) this.serviceProvidersList = await this.actionGetServiceProviders({name: this.filter.service_provider});
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Detail statistics",
        addititional_info: getTranslatedParams(this.filter, this.filterKeys)
      };
      const resp = await this.actionGetItems(this.filter);
      await this.actionLog(this.logObject);
      if (resp?.status == 204) {
        this.is_last = true
        if (!nextPage) notifyWarning()
      } else {
        this.is_last = false
      }
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    } finally {
      this.moreLoading = false;
    }
  }

  async doActionExport(filter: DetailFilterParams): Promise<any> {
    return await this.actionExport(filter);
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChanged(val: DetailFilterParams) {
    this.propFilterClone = val;
  }

  @Watch('propRunFilter', { immediate: true })
  onRunFilter(val: boolean) {
    if (!val) return;
    this.filtered();
    this.propRunFilter = false;
  }
}
